module.exports = {
      id: "appstore-usage",
      viewBox: "0 0 120 40",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#appstore",
      toString: function () {
        return this.url;
      }
    }